import { Pipe, PipeTransform } from '@angular/core';
import { MatchPotentialItemPipe } from './match-potential-item.pipe';
import { IPDFMatching } from '../bulk-upload-pdf-files-step.component';

@Pipe({
  name: 'contractCardFromPdf',
  standalone: true
})
export class ContractCardFromPdfPipe extends MatchPotentialItemPipe implements PipeTransform {

  transform(file: File, PDFMatching: IPDFMatching[] ): number[] {
     return this.getItems(file?.name ?? '', 'contract_control_ids', PDFMatching) as number[];
  }

}
